import React from 'react';
import GenericCadastroPage from './GenericCadastroPage';

export default function PalavraChavePage() {
  const columns = [
    { key: 'descricao', label: 'Descrição' },
  ];

  const fields = [
    { name: 'descricao', label: 'Descrição', required: true },
  ];

  return (
    <GenericCadastroPage
      title="Palavras-Chave"
      description="Gerencie as palavras-chave utilizadas no sistema."
      tableName="palavra_chave_v2"
      columns={columns}
      fields={fields}
    />
  );
}